import { render, staticRenderFns } from "./InstrumentDialog.vue?vue&type=template&id=caf55bba&"
import script from "./InstrumentDialog.vue?vue&type=script&lang=js&"
export * from "./InstrumentDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports